import { PorangeButton } from '@/components/atoms/PorangeButton';
import { GoldButton } from '@/components/atoms/GoldButton';
import { PurpleButton } from '@/components/atoms/PurpleButton';

const ButtonTypes = {
    gold: GoldButton,
    purple: PurpleButton,
    default: PorangeButton,
    porange: PorangeButton,
};

export default function CardPaymentButton({
    color,
    confirmPayment,
    errorMessage,
    withTrial,
    test
}) {
    const Button = ButtonTypes[color];

    return (
        <>
            <Button
                id="submit"
                showLoader={true}
                test={test}
                error={errorMessage}
                color={color}
                className="h-14 my-4 w-full"
                onClick={confirmPayment}
            >
                {withTrial ? "START MY FREE TRIAL" : "Pay now"}
            </Button>
            {errorMessage &&
                <div className={color === "gold"
                    ? "text-white text-xs w-full text-center" : "text-red-500 text-xs w-full text-center"}>
                    {errorMessage}
                </div>}
        </>
    )
}